import { derivedStream } from '@ardoq/rxbeach';
import { map, shareReplay } from 'rxjs/operators';
import { isPresentationMode } from 'env';
import { isViewpointMode$ } from 'traversals/loadedGraph$';
import { fabVisibility$ } from '../mainApp/fab/fabVisibility$';
import { FAB_BOTTOM, FAB_SIZE } from '../mainApp/fab/consts';

export const SINGLE_ROW_VIEW_PANE_FOOTER_HEIGHT = 66; // 50px bar + 2 * 8px margins

type ViewLegendHeightOffsetArgs = {
  isViewpointMode: boolean;
  isPresentationMode: boolean;
  isFabVisible: boolean;
};

export const toViewLegendHeightOffset = ({
  isViewpointMode,
  isPresentationMode,
  isFabVisible,
}: ViewLegendHeightOffsetArgs): number => {
  if (isViewpointMode) return SINGLE_ROW_VIEW_PANE_FOOTER_HEIGHT;
  if (isPresentationMode || !isFabVisible) return 0;
  return FAB_SIZE + FAB_BOTTOM;
};

export const viewLegendHeightOffset$ = derivedStream(
  'viewLegendHeightOffset$',
  isViewpointMode$,
  fabVisibility$
).pipe(
  map(([{ isViewpointMode }, isFabVisible]) =>
    toViewLegendHeightOffset({
      isViewpointMode,
      isPresentationMode: isPresentationMode(),
      isFabVisible,
    })
  ),
  shareReplay({ bufferSize: 1, refCount: true })
);
